import React from 'react'
import * as _ from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { injectIntl, FormattedMessage } from 'react-intl'
//import validator from 'email-validator'
//import phhoneValidate from 'phone'
import { checkPhone } from './../containers/Signin'

import { addEmail, setUserSettings } from '../store/reducers/auth.js'
import { fetchingState } from './../helpers/hocs.js'

import { getIsLogged, getLoggedUser, /*getSettingsInfo*/ } from '../selectors/user.js'

// const locales = {
//   en: { code: 'en', 'title': 'English' },
//   ru: { code: 'ru', 'title': 'Русский' }
// }

const Component = ({
  confirm,
  setPhone, error, phone
}) => {
  function handleInputChange(event) {
    setPhone(event.target.value)
  }

  return (
  <div className='EmailPopup'>
    <h1 className='EmailPopup-h1 EmailPopup-h1-connection'><FormattedMessage id='phone_confirm.connection' /></h1>
    <div className='EmailPopup-kontainer'>
      <div className='EmailPopup-select'>
          <input 
			type="text"
			name="name"
      value={phone}
			className='EmailPopup__field'
			onChange={handleInputChange}
			/>      
      </div>
      {error && <p className='Text GiftCardsCheck__text'><FormattedMessage id='phone_confirm.error' /></p>}
      <button className='EmailPopup-submit' onClick={confirm}><FormattedMessage id='phone_confirm.done' /></button>
    </div>
  </div>
)}

const mapStateToProps = state => {
  return ({
    currentLocale: state.intl.locale,
    isLogged: getIsLogged(state),
    LoggedUser: getLoggedUser(state),
  })
}

const mapDispatchToProps = dispatch => bindActionCreators({ addEmail, setUserSettings }, dispatch)

const mergeProps = (state, dispatch, props) => {return({
  ...props,
  ...state,
})}

export default _.compose(
  fetchingState(),
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  _.withState('phone', 'setPhone', ""),
  _.withState('error', 'setError', ""),
  _.withStateHandlers(
    {
      countryId: window.localStorage.getItem('countryId'),
      locale: window.localStorage.getItem('locale')
    },
    {
      setLocale: () => e => ({ locale: e.target.value }),
      setCountry: () => e => ({ countryId: e.target.value })
    }
  ),
  _.withHandlers({
    confirm: ({ phone, setError, onClose, submit }) => async e => {
      e && e.preventDefault()
      
    if (!checkPhone(phone)) {//неверный формат телефона
        setError(true)
      }
      else {//телефон прошел проверку
        submit(phone)
        setError(false)
      }
    },

  }),
 // _.branch(({ countries }) => !Object.keys(countries).length, _.renderNothing),
  _.lifecycle({
    componentWillMount () {
      if (this.props.LoggedUser)
        this.props.setPhone(this.props.LoggedUser.phone)
    },
    componentWillUnmount () {
      this.props.setPhone("")
    }
  })
)(Component)



// WEBPACK FOOTER //
// ./src/components/PhoneConfirm.jsx